import React from 'react';
import { Reveal } from './Reveal';
const stats: [string, string, string][] = [['12', 'TOMOS COMPLETOS', 'text-brand-blue'], ['5', 'BONOS EXCLUSIVOS', 'text-brand-orange'], ['+400', 'ACTIVIDADES Y RECURSOS', 'text-brand-purple'], ['100%', 'LISTO PARA USAR', 'text-brand-green']];
export function StatsBar() {
  return <section className="border-y border-brand-dark bg-brand-alt py-8" data-id="element-149" data-mp="1jbsl7jkgvbbm">
      <Reveal className="mx-auto grid max-w-5xl grid-cols-2 gap-y-8 px-4 text-center md:grid-cols-4 md:gap-8" data-id="element-150" data-mp="1edhaz7q9eysv">
        {stats.map(([value, label, color], index) => <div key={label} className={`flex flex-col items-center justify-center ${index > 0 ? 'md:border-l md:border-brand-dark' : ''}`} data-id="element-151" data-mp="15kx8txarec3a" data-mpi={index}>
            <span className={`mb-1 font-serif text-3xl font-bold md:text-4xl ${color}`} data-id="element-152" data-mp="10nnjehnde0fg">{value}</span>
            <span className="text-[10px] font-bold uppercase tracking-wider text-brand-gray md:text-xs" data-id="element-153" data-mp="vou72sjtkfgv">
              {label}
            </span>
          </div>)}
      </Reveal>
    </section>;
}